<template>
  <div class="user-avator-dropdown">
    <Dropdown @on-click="handleClick">
      <Badge :dot="!!messageUnreadCount">
        <Avatar :src="userAvator || (oem && oem.icon)" />
      </Badge>
      <Icon :size="18"
            type="md-arrow-dropdown"></Icon>
      <DropdownMenu slot="list">
        <DropdownItem name="message">{{$t('components_main_components_user_user_14')}}<Badge style="margin-left: 10px"
                 :count="messageUnreadCount"></Badge>
        </DropdownItem>
        <!-- <DropdownItem name="reset_password">修改密码</DropdownItem> -->
        <DropdownItem name="logout">{{$t('components_main_components_user_user_15')}}</DropdownItem>
        <!-- <DropdownItem name="sales">前台收银</DropdownItem> -->
      </DropdownMenu>
    </Dropdown>
    <Modal v-model="modalShow"
           @on-ok="handleSubmit"
           width="400"
           :title="$t('components_main_components_user_user_16')">
      <Form ref="account"
            :label-width="120">
        <Form-item :label="$t('components_main_components_user_user_17')"
                   prop="origin_password">
          <Input type="password"
                 v-model="origin_password" />
        </Form-item>
        <Form-item :label="$t('components_main_components_user_user_18')"
                   prop="password">
          <Input type="password"
                 v-model="password" />
        </Form-item>
        <Form-item :label="$t('components_main_components_user_user_19')"
                   prop="password2">
          <Input type="password"
                 v-model="password2" />
        </Form-item>
      </Form>
    </Modal>
  </div>
</template>

<script>
import i18n from '../../../../locales/index'

import './user.less'
import { mapActions, mapGetters, mapState } from 'vuex'
export default {
  name: 'User',
  data () {
    return {
      modalShow: false,
      origin_password: '',
      password: '',
      password2: ''
    }
  },
  computed: {
    ...mapGetters('editor', ['me']),
    ...mapState('oem', ['oem'])
  },
  props: {
    userAvator: {
      type: String
    },
    messageUnreadCount: {
      type: Number,
      default: 0
    }
  },
  methods: {
    ...mapActions('editor', ['logout', 'change_pwd']),
    handleSubmit () {
      if (this.password !== this.password2) {
        this.$Message.error(i18n.t('components_main_components_user_user_20'))
        return
      }
      this.change_pwd({
        origin_password: this.origin_password,
        new_password: this.password
      })
      this.modalShow = false
    },
    handleClick (name) {
      switch (name) {
        case 'logout':
          this.logout()
          break
        case 'message':
          // this.message()
          this.$router.push(`/messages`)
          break
        case 'reset_password':
          this.modalShow = true
          break
      }
    }
  }
}
</script>
